<!-- Login / Profile dropdown in navbar -->
<a
  [href]="profileUrl"
  appUnsavedFormCheck
  class="navigation__profile-user d-md-block d-none"
>
  <div
    *ngIf="!sessionService.authenticated; else profileLink"
    class="nav-link text-center"
  >
    <span
      appRequireLogin
      class="d-flex align-items-center"
    >
      <img
        class="rounded-circle nav-profile__avatar"
        appDefaultAvatar
        alt="user-avatar"
      />
      <ng-icon
        name="matArrowDropDownOutline"
        class="ms-1 d-none d-md-block font-size-base text-black"
      ></ng-icon>
    </span>
  </div>

  <ng-template #profileLink>
    <div class="nav-link text-center">
      <ng-container *ngTemplateOutlet="profileAvatarRef"></ng-container>
    </div>
  </ng-template>
</a>

<!-- Dropdown -->
<div
  class="nav-profile__dropdown-menu dropdown-menu dropdown px-0"
  aria-labelledby="dropdownMenuButton"
>
  <!-- Sections on mobiles -->
  <section class="d-block d-md-none">
    <ng-container *ngTemplateOutlet="profileActions"></ng-container>

    <ng-container *ngTemplateOutlet="appInformationRef"></ng-container>

    <ng-container *ngTemplateOutlet="loginLogoutRef"></ng-container>
  </section>

  <!-- Logged-in user info -->
  <section
    class="nav-profile d-none d-md-block"
    *ngIf="profile && sessionService.authenticated"
  >
    <div class="navigation__content--padding">
      <div class="d-flex">
        <div class="d-flex align-items-center">
          @let alt = $any(profile?.image)?.alt || 'user-avatar';

          <img
            [src]="$any(profile?.image)?.url || profile?.image"
            appDefaultAvatar
            [alt]="alt"
            [ngbTooltip]="
              $any(profile?.image)?.title ||
              ('Profile.Default.MyProfileImage' | translate)
            "
            container="body"
            class="rounded-circle nav-profile__avatar nav-profile__avatar--small"
          />
        </div>

        <ul class="nav-profile__text list-unstyled">
          <li class="nav-profile__name text-truncate fw-bold">
            {{ profile.firstName }} {{ profile.lastName }}
          </li>

          <li class="text-truncate">
            {{ profile.email }}
          </li>

          <li class="text-truncate">
            {{ profile.phone }}
          </li>

          <li class="text-truncate">
            {{ profile.company?.name || profile.company }}
          </li>
        </ul>
      </div>

      <a
        appUnsavedFormCheck
        [href]="profileUrl"
        class="btn btn-outline-primary w-100 py-0 mt-2 text-decoration-none d-flex align-items-center justify-content-center"
        translate
      >
        <ng-icon
          name="matPerson"
          class="me-1"
        ></ng-icon>
        My Profile
      </a>
    </div>

    <ng-container *ngTemplateOutlet="profileActions"></ng-container>

    <ng-container *ngTemplateOutlet="appInformationRef"></ng-container>

    <ng-container *ngTemplateOutlet="loginLogoutRef"></ng-container>
  </section>
</div>

<div
  class="dropdown-menu dropdown px-0"
  aria-labelledby="dropdownMenuLogin"
>
  <section
    class="nav-profile d-none d-md-block"
    aria-labelledby="dropdownMenuLink"
    *ngIf="!sessionService.authenticated"
  >
    <ng-container *ngTemplateOutlet="appInformationRef"></ng-container>

    <ng-template [ngTemplateOutlet]="loginRef"></ng-template>
  </section>
</div>

<ng-template #profileActions>
  <ng-container *ngIf="sessionService.authenticated">
    <div class="navigation__content--padding">
      <div
        class="text-start nav-profile__action-item fw-bold text-lg-center"
        translate
      >
        UI.Nav-Profile.Account
      </div>

      <div
        *ngIf="profile"
        class="nav-profile__action-item d-md-none d-flex align-items-center"
      >
        <ng-container *ngTemplateOutlet="profileAvatarRef"></ng-container>
        <a class="text-truncate fw-bold ps-2"
          >{{ profile.firstName }} {{ profile.lastName }}</a
        >
      </div>

      <div class="nav-profile__action-item">
        <a
          appRequireLogin
          appUnsavedFormCheck
          (click)="storePreviousUrl()"
          [href]="changePasswordUrl"
          class="nav-link p-0 text-lg-center text-start"
        >
          {{ 'ChangePassword' | translate }}
        </a>
      </div>

      <div class="nav-profile__action-item">
        <a
          appRequireLogin
          appUnsavedFormCheck
          (click)="storePreviousUrl()"
          [href]="changeEmailUrl"
          class="text-start nav-link p-0 text-lg-center"
        >
          {{ 'UI.Nav-Profile.Change-email' | translate }}
        </a>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #appInformationRef>
  <app-nav-information
    [navigateUrl]="tenantUrl"
    [isTenantAdmin]="profile?.isTenantAdmin"
  ></app-nav-information>
</ng-template>

<ng-template #profileAvatarRef>
  <a
    [href]="profileUrl"
    appUnsavedFormCheck
    class="d-flex align-items-center"
  >
    @let alt = $any(profile?.image)?.alt || 'user-avatar';

    <img
      [src]="$any(profile?.image)?.url || profile?.image"
      class="rounded-circle nav-profile__avatar"
      appDefaultAvatar
      [alt]="alt"
      [ngbTooltip]="
        $any(profile?.image)?.title ||
        ('Profile.Default.MyProfileImage' | translate)
      "
      container="body"
      placement="left"
    />
    <ng-icon
      name="matArrowDropDownOutline"
      class="ms-1 font-size-base text-black d-none d-md-block"
    ></ng-icon>
  </a>
</ng-template>

<ng-template #loginRef>
  <div class="nav-profile__action-item nav-profile__action-item--logout p-0">
    <button
      translate
      class="btn-unstyled w-100 p-2"
      appRequireLogin
      [callBackLoginPage]="getCallBackLoginPage()"
      (click)="goToLoginPage()"
    >
      Login
    </button>
  </div>
</ng-template>

<ng-template #loginLogoutRef>
  <div
    *ngIf="sessionService.authenticated; else loginRef"
    appUnsavedFormCheck
    (clickAfterChecking)="logout($event)"
    class="nav-profile__action-item navigation__content--padding desktop-link nav-link p-3"
    [class.justify-content-start]="isMobile"
    [class.is-mobile]="isMobile"
    translate
  >
    <ng-icon
      name="matLogoutOutline"
      class="fs-6"
    ></ng-icon>

    Log out
  </div>
</ng-template>
